const statuses = {
	0: 'Inativo', 
	1: 'Ativo'
};

export {
	statuses
}